import { Switch } from '@thanx/uikit/switch'
import type { Fields as Campaign } from 'models/Campaign'
import React from 'react'
import { useSelector } from 'react-redux'
import ContinueButton from 'scenes/CampaignCenter/Builder/components/ContinueButton'
import TopBar from 'scenes/CampaignCenter/Builder/components/TopBar'
import InfoModal from 'scenes/CampaignCenter/components/InfoModal'
import { selectCampaignTypeByType } from 'selectors/campaignType'
import Audience from './Substeps/Audience'
import Incentive from './Substeps/Incentive'
import Messaging from './Substeps/Messaging'

type Props = {
  campaign: Campaign
  isSaving: boolean
  canProceed: boolean
  currentSubstep: string
  triggerSave: () => Promise<void>
  setCurrentStep: (step: string) => void
  setNextSubstep: () => void
  showValidationErrors: () => void
}

const View: React.FC<Props> = props => {
  const {
    campaign,
    isSaving,
    canProceed,
    currentSubstep,
    triggerSave,
    setCurrentStep,
    setNextSubstep,
    showValidationErrors,
  } = props
  const campaignType = useSelector(state =>
    selectCampaignTypeByType(state, campaign?.type)
  )

  function continueClick() {
    if (currentSubstep === 'messaging') {
      setCurrentStep('review')
    } else {
      setNextSubstep()
    }
  }

  return (
    <div>
      <TopBar
        triggerSave={triggerSave}
        campaign={campaign}
        infoModal={
          <InfoModal
            className="pull-left padding-top-micro margin-right-medium"
            campaignType={campaign?.type}
            campaignCategory={campaignType?.category}
            withinBuilder
          >
            <i
              style={{ marginTop: '10px' }}
              className="fa fa-info-circle fa-2x cursor-pointer"
            />
          </InfoModal>
        }
      >
        <ContinueButton onClick={continueClick} />
      </TopBar>
      <div className="container">
        <Switch condition={currentSubstep === 'audience'}>
          <Audience campaign={campaign} />
        </Switch>
        <Switch condition={currentSubstep === 'incentive'}>
          <Incentive
            campaign={campaign}
            canProceed={canProceed}
            showValidationErrors={showValidationErrors}
            isSaving={isSaving}
            triggerSave={triggerSave}
          />
        </Switch>
        <Switch condition={currentSubstep === 'messaging'}>
          <Messaging
            campaign={campaign}
            canProceed={canProceed}
            showValidationErrors={showValidationErrors}
          />
        </Switch>
      </div>
    </div>
  )
}

export default View
